var schoolInfo = [];
var posttags = '';
$('.nearby-section').hide();

function ajax_search(filter = [], posttags = '') {

		showAjaxLoader();

		$.get(`${HOST}/schools/ajax_similar_schools.php`, {
				Tags: posttags.split(','), Filters: filter, page: 1, page_type: 'SEARCH',
				excluded_school_ids: [schoolId]
		}).done(({data = []}) => {

				$('.near-by-header').show();
				$('#nearby-list').show();

				setNearbyResults(data);

				$('.nearby-section').show();

				const nearby_card = $('.nearby-card');
				if (nearby_card.length === 0) $('#near-by-school').hide();

				/*if (nearby_card.length > 4 || window.matchMedia("(max-width: 1024px)").matches) {
						$('#similar-schools').slick({
								slidesToShow: 4,
								slidesToScroll: 1,
								autoplay: true,
								autoplaySpeed: 2000,
								lazyLoad: 'ondemand',
								dots: true,
								responsive: [{
										breakpoint: 1024,
										settings: {slidesToShow: 3, slidesToScroll: 2, infinite: true, dots: true}
								}, {
										breakpoint: 600,
										settings: {slidesToShow: 2, slidesToScroll: 2}
								}, {
										breakpoint: 480,
										settings: {slidesToShow: 1, slidesToScroll: 1, arrows: false}
								}]
						});
				} else {
						$(".nearby-card").css("width", "198px");
				}*/
		}).fail(() => hideAjaxLoader()).always(() => hideAjaxLoader());
}

//
// var boards = [
//     {"id": "1", "board": "CBSE"},
//     {"id": "2", "board": "ICSE"},
//     {"id": "3", "board": "IB"},
//     {"id": "4", "board": "Other boards"},
//     {"id": "5", "board": "State Board"},
//     {"id": "6", "board": "IGCSE"}
// ];

var coedType = [
		{"id": "1", "coedtype": "Co-Ed School"},
		{"id": "2", "coedtype": "Only Girls School"},
		{"id": "3", "coedtype": "Only Boys School"}
];

// var regions = [
//     {"id": "1", "name": "north"},
//     {"id": "2", "name": "east"},
//     {"id": "3", "name": "south"},
//     {"id": "4", "name": "west"},
//     {"id": "5", "name": "central"}
// ];

const regionsMaps = {
		north: ["north", "central", "west"],
		east: ["east", "central", "north"],
		south: ["south", "central", "west"],
		west: ["north", "central", "west"],
		central: ["south", "central", "west"]
};


function getFeeRange(schoolType, fee) {
		fee = parseInt(fee);
		schoolType = parseInt(schoolType);

		var feeStr = '';
		if (schoolType == 1) {
				if (fee < 30000) {
						feeStr = '<30000';
				} else if (fee >= 30000 && fee < 50000) {
						feeStr = '>30000_<50000';
				} else if (fee >= 50000 && fee < 70000) {
						feeStr = '>50000_<70000';
				} else if (fee >= 70000 && fee < 100000) {
						feeStr = '>70000_<100000';
				} else if (fee >= 100000 && fee < 200000) {
						feeStr = '>100000_<200000';
				} else if (fee >= 200000) {
						feeStr = '>200000';
				}
		} else if (schoolType == 2) {
				let preFees = fee / 12;
				if (preFees < 2500) {
						feeStr = '<2500';
				} else if (preFees >= 2500 && preFees < 5000) {
						feeStr = '>2500_<5000';
				} else if (preFees >= 5000 && preFees < 8000) {
						feeStr = '>5000_<8000';
				} else if (preFees >= 8000) {
						feeStr = '>8000';
				}
		} else if (schoolType == 3 || schoolType == 4) {
				if (fee > 500 && fee < 300000) {
						feeStr = '>500_<300000';
				} else if (fee >= 300000 && fee < 500000) {
						feeStr = '>300000_<500000';
				} else if (fee >= 500000 && fee < 700000) {
						feeStr = '>500000_<700000';
				} else if (fee >= 700000 && fee < 1000000) {
						feeStr = '>700000_<1000000';
				} else if (fee >= 1000000) {
						feeStr = '>1000000';
				}
		}
		return "fee-" + feeStr;
}

function getBoards(boardStr) {
		let newBoardStr = '';
		let boardsArr = boardStr.split(',');
		boardsArr.forEach((value) => {
				value = value.trim();
				if (value == 'cbse' || value == 'CBSE') {
						newBoardStr = getBoardStr(newBoardStr, 'board-1');
				} else if (value == 'icse' || value == 'ICSE') {
						newBoardStr = getBoardStr(newBoardStr, 'board-2');
				} else if (value == 'ib' || value == 'IB') {
						newBoardStr = getBoardStr(newBoardStr, 'board-3');
				} else if (value == 'other boards' || value == 'Other boards') {
						newBoardStr = getBoardStr(newBoardStr, 'board-4');
				} else if (value == 'state board' || value == 'State Board') {
						newBoardStr = getBoardStr(newBoardStr, 'board-5');
				} else if (value == 'igcse' || value == 'IGCSE') {
						newBoardStr = getBoardStr(newBoardStr, 'board-6');
				}
		});
		return newBoardStr;
}

function getBoardStr(newBoardStr, newBoard) {
		if (newBoardStr == '') {
				return newBoardStr + newBoard;
		} else {
				return newBoardStr + ', ' + newBoard;
		}
}

function getGenderClassification(genderClass) {
		let newGenderClass = '';
		switch (genderClass) {
				case "Co-Ed School":
						newGenderClass = newGenderClass + 'coed-1';
						break;
				case "Only Girls School":
						newGenderClass = newGenderClass + 'coed-2';
						break;
				case "Only Boys School":
						newGenderClass = newGenderClass + 'coed-3';
						break;
				default:
						newGenderClass = '';
						break
		}
		return newGenderClass;
}

function getRegions(id) {
		switch (parseInt(id)) {
				case 1:
						return getRegionStr('north');
						break;
				case 2:
						return getRegionStr('east');
						break;
				case 3:
						return getRegionStr('south');
						break;
				case 4:
						return getRegionStr('west');
						break;
				case 5:
						return getRegionStr('central');
						break;
				default:
						return '';
						break;
		}
}

function getRegionStr(regionName) {
		let regionsStr = '';
		regionsMaps[regionName].forEach((resgionMap) => {
				regions.forEach((region) => {
						if (resgionMap == region.name) {
								if (regionsStr == '') {
										regionsStr = regionsStr + 'region-' + region.id;
								} else {
										regionsStr = regionsStr + ', ' + 'region-' + region.id;
								}
						}
				});
		});
		return regionsStr;
}


let similarSchoolLoaded = false;
function loadNearbySchools(schoolType, fees, boardStr, genderClassification, regionId) {
	if(similarSchoolLoaded) return;

	similarSchoolLoaded = true;

		posttags = '';

		let schType = schoolType;
		if (schType === 4) schType = 3;

		let filter = [
				{'distance_max': 10},
				{'city_latitude': lat},
				{'city_longitude': lng},
				{'school_type': schType},
				{'city_name': cityNameStr.trim()}
		];


		if (!!regionId || [4, 3].includes(schoolType)) {
				filter = filter.filter(obj => {
						const del_keys = Object.keys(obj)
								.filter(e => [
										'distance_max', 'city_latitude', 'city_longitude', 'city_name'
								].indexOf(e) !== -1);
						del_keys.forEach(k => delete obj[k]);
						return Object.keys(obj).length > 0;
				});
		}

		if (schoolType === 2) posttags = getFeeRange(schoolType, fees);
		else {
				posttags = getFeeRange(schoolType, fees) + ', ' + getBoards(boardStr) + ', ' + getGenderClassification(genderClassification) + ', ' + getRegions(regionId);
		}
		posttags = posttags.replace(',,', ',');
		console.log('this file');
		ajax_search(filter, posttags);
}

function setNearbyResults(schoolData) {
debugger;
		let template = '';

		schoolData = schoolData.schools.filter(({id}) => schoolId !== id).slice(0, 5);

		schoolData.forEach(school => {
				let {final_url = '', imgpthm = '', name = '', distance = 0} = school || {};

				template += `<div class="col-12 col-lg-6 position-relative">
			<div class="similar-school border border-radius-10 d-flex justify-content-between flex-wrap">
				<img
					width="111"
					height="111"
					src="${imgpthm}" loading="lazy" alt="${name.toLowerCase()}">
				<div class="similar-school-info d-flex flex-column justify-content-between">
					<a href="${final_url}" class="text-capitalize text-black text-decoration-none similar-school-name text-truncate font-weight-bold">
						${name.toLowerCase()}
					</a>
					<div class="similar-school-rating">
						<div class="rating-wrapper d-flex align-items-center">
							<span class="fw-semibold">${school.parent_rating.avgRating ?? 0}</span>
							<i class="basic yellow position-relative ml-2 d-inline-block" data-star="${school.parent_rating.avgRating ?? 0}"></i>
							<span class="fw-semibold">(${school.parent_rating.rateCount ?? 0} votes)</span>
						</div>
					</div>
					<span class="d-block similar-school-location text-truncate fs-14 fw-medium">${getAddress(school)}</span>
				</div>
			</div>
			<a href="${final_url}" class="school_link_overlay">${name}</a>
		</div>`;
		});

		if (template === '') $('.nearby-section').hide();

		$('#similar-schools').html(template);
}


function getAddress(value) {
		return ([3, 4].includes(parseInt(value.typeid))) ? value.city_name + ", " + value.state_name : value.address1;
}

function getDistance(distance) {
		let distanceStr = '';
		if (distance && distance > 0) {
				distanceStr = `<p class="map_marker" style="margin: 0;">
            <i class="fa fa-map-marker"></i> ${distance} Kms
         </p>`;
		} else {
				distanceStr = `<p class="map_marker" style="display: none;">
            <i class="fa fa-map-marker"></i> ${distance} Kms
         </p>`;
		}
		return distanceStr;
}


function hideAjaxLoader() {
		$('.loader').hide();
}

function showAjaxLoader() {
		$('.loader').show();
}

function handleSimilarSchoolTouchStart() {
	loadNearbySchools(schoolType, fees, boardStr, genderClassification, regionId);
	document.removeEventListener("touchstart", handleSimilarSchoolTouchStart);
}

function handleSimilarSchoolScroll() {
	if (window.scrollY > 0) {
		loadNearbySchools(schoolType, fees, boardStr, genderClassification, regionId);
		window.removeEventListener("scroll", handleSimilarSchoolScroll);
	}
}

function handleSimilarSchoolMouseMove(event) {
	loadNearbySchools(schoolType, fees, boardStr, genderClassification, regionId);;
	document.removeEventListener("mousemove", handleSimilarSchoolMouseMove);
}

// loadNearbySchools(schoolType, fees, boardStr, genderClassification, regionId);

document.addEventListener("DOMContentLoaded", function(event) {
	window.addEventListener("scroll", handleSimilarSchoolScroll);
	document.addEventListener("touchstart", handleSimilarSchoolTouchStart);
	document.addEventListener("mousemove", handleSimilarSchoolMouseMove);
});
	

